module.exports = __webpack_public_path__ + "img/yhSec.27c229a5.png";